import { useEffect } from 'react';
import { useLocation } from 'react-router';

const titles: Record<string, string> = {
  '/': 'Overview',
  '/calls': 'Calls',
  '/contacts': 'Contacts',
  '/reports': 'Reports',
  '/team': 'Team',
  '/exclusions': 'Excluded numbers',
  '/ai': 'AI analysis',
  '/webhooks': 'Webhooks',
  '/api-apps': 'API & Apps',
  '/recordings': 'Recording storage',
  '/billing': 'Plan & billing',
  '/account': 'Account',
  '/help': 'Help & support',
  '/chat': 'Support chat',
  '/welcome': 'Connect your first phone',
  '/login': 'Sign in',
  '/signup': 'Create account',
  '/signup/verify': 'Verify your email',
  '/forgot-password': 'Forgot password',
  '/reset-password': 'Reset password',
  '/oauth/consent': 'Connect an application',
  '/dashboard/oauth/consent': 'Connect an application',
};

/** Only page navigation moves focus; filtering and pagination keep the current control focused. */
export function NavigationAccessibility() {
  const { pathname, search } = useLocation();
  const step = pathname === '/welcome' ? new URLSearchParams(search).get('step') : null;
  useEffect(() => {
    document.title = `${titles[pathname] || 'Page not found'} · CallSync`;
    window.scrollTo({ top: 0, behavior: 'instant' });
    const focusHeading = () => {
      const heading = document.querySelector<HTMLElement>('main h1');
      if (!heading || !heading.getClientRects().length) return false;
      if (pathname === '/welcome') document.title = `${heading.textContent} · CallSync`;
      heading.tabIndex = -1;
      heading.focus({ preventScroll: true });
      return true;
    };
    // Lazy routes may still be showing a skeleton. Wait for the actual page heading.
    const observer = new MutationObserver(() => {
      if (focusHeading()) observer.disconnect();
    });
    const frame = requestAnimationFrame(() => {
      if (!focusHeading())
        observer.observe(document.getElementById('root')!, { childList: true, subtree: true });
    });
    return () => {
      cancelAnimationFrame(frame);
      observer.disconnect();
    };
  }, [pathname, step]);
  return (
    <a className="skip-link" href="#main-content">
      Skip to content
    </a>
  );
}
